// extracted by mini-css-extract-plugin
export default {"margins":"ButtonsPage-margins__I8"};